import useService from '@modules/ServiceModule/useService';
import useTasks from '@modules/TasksModule/hooks/useTasks';
import TaskView from '../TaskView/TaskView';
import MultiTenantTaskView from '../MultiTenantTaskView';

type Props = {
  taskId: string;
  show?: boolean;
};

const CustomerTaskView = ({ taskId, show = false }: Props) => {
  const service = useService();
  const { taskById } = useTasks();
  const task = taskById[taskId];

  const isServiceReady = !service.loading && !service.error;

  if (!task) {
    return <div>Task not found</div>;
  } else if (!isServiceReady) {
    return null;
  } else if (task.tenantId) {
    return (
      <TaskView
        key={task.id}
        taskId={task.id}
        show={show}
        taskTenantId={task.tenantId}
      />
    );
  } else {
    // in the case for outbound call to a number, we will not have an tenant id,
    // render a multi-tenant task view
    return show && <MultiTenantTaskView key={task.id} taskId={task.id} />;
  }
};

export default CustomerTaskView;
